// Fuso horario da empresa (Configuracoes). Todas as datas/horas do painel sao
// exibidas nele - nao no fuso do navegador de quem esta olhando.
let _tz = "America/Recife";

export function setTenantTz(tz) {
  if (tz && typeof tz === "string") _tz = tz;
}

export function getTenantTz() {
  return _tz;
}

export function tzOpts(extra = {}) {
  return { timeZone: _tz, ...extra };
}

export const TIMEZONE_OPTIONS = [
  ["America/Noronha", "Fernando de Noronha (UTC-2)"],
  ["America/Recife", "Recife / Nordeste (UTC-3)"],
  ["America/Fortaleza", "Fortaleza (UTC-3)"],
  ["America/Bahia", "Salvador / Bahia (UTC-3)"],
  ["America/Belem", "Belém (UTC-3)"],
  ["America/Sao_Paulo", "Brasília / São Paulo (UTC-3)"],
  ["America/Campo_Grande", "Campo Grande (UTC-4)"],
  ["America/Cuiaba", "Cuiabá (UTC-4)"],
  ["America/Manaus", "Manaus (UTC-4)"],
  ["America/Porto_Velho", "Porto Velho (UTC-4)"],
  ["America/Boa_Vista", "Boa Vista (UTC-4)"],
  ["America/Rio_Branco", "Rio Branco (UTC-5)"],
  ["America/Argentina/Buenos_Aires", "Buenos Aires (UTC-3)"],
  ["America/Montevideo", "Montevidéu (UTC-3)"],
  ["America/Asuncion", "Assunção"],
  ["America/Santiago", "Santiago"],
  ["America/Bogota", "Bogotá (UTC-5)"],
  ["America/New_York", "Nova York"],
  ["Europe/Lisbon", "Lisboa"],
  ["UTC", "UTC"],
];
